import React, { ReactNode } from 'react';
import { mergeClasses } from '@/utils/style';

type CalculatorResultRowProps = {
	title: ReactNode;
	value: ReactNode;
	highlighted?: boolean;
};

export function CalculatorResultRow({
	title,
	value,
	highlighted = false,
}: CalculatorResultRowProps) {
	return (
		<div className="flex w-full items-center justify-between gap-4 text-base">
			<p className={mergeClasses('text-white', highlighted ? 'font-semibold' : 'font-normal')}>
				{title}
			</p>
			<p
				className={mergeClasses(
					'text-right text-white',
					highlighted ? 'font-semibold' : 'font-normal'
				)}
			>
				{value}
			</p>
		</div>
	);
}
